<template>
    <transition name="fade-scale">
        <div class="brt-dialog" v-if="visible" @click="close">
            <div class="brt-dialog-main fade-scale">
                <div class="close" @click="close">
                    <i class="iconfont icon-close-02"></i>
                </div>
                <div class="brt-dia-head" v-if="title">
                    <span>{{ title }}</span>
                </div>
                <div class="brt-dia-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Dialog",
        data () {
            return {
                visible: this.value
            }
        },
        props: {
            value: {
                default: false
            },

            title: {
                default: ''
            }
        },
        watch: {
            value (boolean) {
                this.visible = boolean;
            }
        },
        methods: {
            close () {
                this.$emit('input', this.visible = false);
            }
        }

    }
</script>

<style lang="less">
    @import "../../styles/cssBlock.less";

    .brt-dialog {
        .fixedByCover();
        pointer-events: auto;
        background-color: @maskBgColor;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9002;

        &[title-background] {
            .brt-dialog-main {
                > .brt-dia-head {
                    background-color: #F8F8F8;
                }
            }
        }
    }

    .brt-dialog-main {
        width: 75%;
        max-width: @600px;
        min-height: 100px;
        background-color: #FFFFFF;
        border-radius: @radiusNumber;
        margin-top: -@200px;
        overflow: hidden;
        position: relative;

        @headHeight     : @90px;

        > .close {
            @size       : @headHeight - @2px;
            position: absolute;
            right: 0;
            top: 0;
            width: @size;
            height: @size;
            line-height: @size;
            text-align: center;

            > .iconfont {
                font-size: @36px;
                color: @fontColorA2;
            }
        }

        > .brt-dia-head {
            height: @headHeight;
            line-height: @headHeight;
            padding: 0 @spacingNumber;
            color: @fontColorA1;
        }
    }

</style>
